export default {
    getFelirtReceptAdditionalConfig : state => state.felirtReceptAdditionalConfig,
    getFelirtReceptTableSearchFields : state => state.felirtReceptTableSearchFields,
    getFelirtReceptTableActions : state => state.felirtReceptTableActions,
    getFelirtReceptTableRowActions : state => state.felirtReceptTableRowActions,
    getFelirtReceptTableHeaderFields : state => state.felirtReceptTableHeaderFields,
    getFelirtReceptDetailsViewModalFields: state => state.felirtReceptDetailsViewModalFields,

    getKiadottReceptAdditionalConfig: state => state.kiadottReceptAdditionalConfig,
    getKiadottReceptTableActions: state => state.kiadottReceptTableActions,
    getKiadottReceptTableRowActions: state => state.kiadottReceptTableRowActions,
    getKiadottReceptTableHeaderFields: state => state.kiadottReceptTableHeaderFields,
    getKiadottReceptDetailsViewModalFields: state => state.kiadottReceptDetailsViewModalFields,

    getGyseReceptAdditionalConfig: state => state.gyseReceptAdditionalConfig,
    getGyseReceptTableActions: state => state.gyseReceptTableActions,
    getGyseReceptSearchFields: state => state.gyseReceptSearchFields,
    getGyseReceptTableRowActions: state => state.gyseReceptTableRowActions,
    getGyseReceptTableHeaderFields: state => state.gyseReceptTableHeaderFields
}
